import { Pipe, PipeTransform } from '@angular/core';
import { formatVisitDuration } from '../../framework/device-utils';

@Pipe({ name: 'visitDuration', standalone: false })
export class VisitDurationPipe implements PipeTransform {
  transform(seconds: number): string {
    return formatVisitDuration(seconds);
  }
}
